module.exports = __webpack_public_path__ + "img/uploadid.d20621bb.svg";